import {Injectable} from '@angular/core';
import {Bafor} from '../model/bafor';

@Injectable({providedIn: 'root'})
export class BaforService {
    private readonly SPLIT_SYMBOL = ':';
    private readonly PREFIX = `urn${this.SPLIT_SYMBOL}bafor${this.SPLIT_SYMBOL}`;

    private readonly VERFAHREN_STEP = 'step';
    private readonly OBJEKTTYP_STEP_PERSON = 'person';
    private readonly OBJEKTTYP_STEP_BETRIEB = 'betrieb';

    private readonly VERFAHREN_KIWI = 'kiwi';
    private readonly OBJEKTTYP_KINDERGELDFALL = 'kindergeldfall';

    private readonly VERFAHREN_UBVONLINE = 'ubvonline';
    private readonly OBJEKTTYP_UBVONLINE_BEVOLLMAECHTIGTER = 'unternehmensbevollmaechtigter';

    parse(input = ''): Bafor | null {
        const match = /^urn:bafor:([a-z]+):([a-z]+):([a-z]+):([A-Za-z0-9-]+)$/.exec(input);

        if (!match) {
            return null;
        }

        const [, verfahren, objekttyp, fachschluesselTyp, referenzId] = match;

        return {
            verfahren,
            objekttyp,
            fachschluesselTyp,
            referenzId,
        };
    }

    getReferenzId(bafor: Bafor | null): string | null {
        if (!bafor?.referenzId) {
            return null;
        }

        if (this.isUbvonlineBevollmaechtigter(bafor)) {
            const idx = bafor.referenzId.lastIndexOf('-');
            return idx >= 0 ? bafor.referenzId.substring(idx + 1) : bafor.referenzId;
        }

        return bafor.referenzId;
    }

    isStepPerson(bafor: Bafor): boolean {
        return bafor.verfahren === this.VERFAHREN_STEP && bafor.objekttyp === this.OBJEKTTYP_STEP_PERSON;
    }

    isStepBetrieb(bafor: Bafor): boolean {
        return bafor.verfahren === this.VERFAHREN_STEP && bafor.objekttyp === this.OBJEKTTYP_STEP_BETRIEB;
    }

    isKiwiKindergeldfall(bafor: Bafor): boolean {
        return bafor.verfahren === this.VERFAHREN_KIWI && bafor.objekttyp === this.OBJEKTTYP_KINDERGELDFALL;
    }

    isUbvonlineBevollmaechtigter(bafor: Bafor): boolean {
        return (
            bafor.verfahren === this.VERFAHREN_UBVONLINE &&
            bafor.objekttyp === this.OBJEKTTYP_UBVONLINE_BEVOLLMAECHTIGTER
        );
    }

    toString(bafor: Bafor): string {
        return (
            this.PREFIX +
            bafor.verfahren +
            this.SPLIT_SYMBOL +
            bafor.objekttyp +
            this.SPLIT_SYMBOL +
            bafor.fachschluesselTyp +
            this.SPLIT_SYMBOL +
            bafor.referenzId
        );
    }
}



